import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QueryKeys } from '@app/constants/queryKeys';
import { ThirdwebSDK } from '@thirdweb-dev/react';
import erc20Abi from '../../../abis/erc20.json';
import { parseUnits } from '@app/helpers/format';
import { Chain } from '@thirdweb-dev/chains';
import { Token } from '@app/types/token';
import { BigNumber, Signer } from 'ethers';

async function mutation({
  network,
  token,
  spenderAddress,
  amount,
  signer
}: {
  network: Chain | undefined;
  token: Token | undefined;
  spenderAddress: string | undefined;
  amount: string | BigNumber;
  signer: Signer | undefined;
}) {
  if (!network || !token || !spenderAddress || !amount || !signer) {
    return null;
  }

  const sdk = ThirdwebSDK.fromSigner(signer);

  const contract = await sdk.getContract(token.contractAddress, erc20Abi);

  // @ts-ignore
  const res = await contract.call('approve', [
    spenderAddress,
    typeof amount === 'string' ? parseUnits(amount, token.decimals) : amount
  ]);

  return res;
}

export function useApproval(isBulk?: boolean) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: mutation,
    onSuccess: async () => {
      if (isBulk) {
        await queryClient.invalidateQueries({
          queryKey: [QueryKeys.BULK_TOKEN_ALLOWANCE]
        });
      } else {
        await queryClient.invalidateQueries({
          queryKey: [QueryKeys.TOKEN_ALLOWANCE]
        });
      }
    }
  });
}
